export const fr = {
  // Common
  common: {
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
    sunday: 'Dimanche',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    add: 'Ajouter',
    close: 'Fermer',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    confirm: 'Confirmer',
    yes: 'Oui',
    no: 'Non',
    search: 'Rechercher',
    filter: 'Filtrer',
    clear: 'Effacer',
    apply: 'Appliquer',
    reset: 'Réinitialiser',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    first: 'Premier',
    last: 'Dernier',
    today: 'Aujourd\'hui',
    export: 'Exporter',
    import: 'Importer',
    download: 'Télécharger',
    upload: 'Téléverser',
    copy: 'Copier',
    copied: 'Copié',
    expand: 'Développer',
    collapse: 'Réduire',
    show: 'Afficher',
    hide: 'Masquer',
    settings: 'Paramètres',
    language: 'Langue',
    colleague: 'Collègue',
    year: 'Année',
    site: 'Site',
    saving: 'Enregistrement...',
    deleting: 'Suppression...',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    legend: 'Légende'
  },

  // Authentication
  auth: {
    signIn: 'Se connecter',
    signOut: 'Se déconnecter',
    signUp: 'S\'inscrire',
    email: 'Adresse e-mail',
    password: 'Mot de passe',
    site: 'Site',
    firstName: 'Prénom',
    lastName: 'Nom',
    mobile: 'Mobile',
    signInToAccount: 'Connectez-vous à votre compte',
    invalidCredentials: 'Identifiants invalides',
    registrationFailed: 'Échec de l\'inscription',
    loginFailed: 'Échec de la connexion',
    signingIn: 'Connexion en cours...',
    loginRequired: 'Vous devez être connecté pour demander des congés',
    authenticationRequired: 'Vous devez être connecté pour accéder à cette fonctionnalité',
    loginSection: 'Mon Calendrier',
    changePassword: 'Changer le mot de passe',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    passwordChanged: 'Mot de passe changé avec succès',
    passwordChangeFailed: 'Échec du changement de mot de passe',
    passwordsDontMatch: 'Les mots de passe ne correspondent pas',
    passwordTooShort: 'Le mot de passe doit contenir au moins 8 caractères',
    passwordMinLength: 'Au moins 8 caractères',
    passwordUppercase: 'Une lettre majuscule',
    passwordNumber: 'Un chiffre',
    passwordSpecialChar: 'Un caractère spécial',
    passwordMatch: 'Les mots de passe correspondent',
    passwordsRequired: 'Le mot de passe actuel et le nouveau sont requis',
    incorrectPassword: 'Le mot de passe actuel est incorrect',
    userNotFound: 'Utilisateur non trouvé',
    mustChangePassword: 'Changez votre mot de passe',
    mustChangePasswordMessage: 'Pour des raisons de sécurité, vous devez changer votre mot de passe avant de continuer.',
    emailRequired: 'L\'e-mail est requis',
    passwordRequired: 'Le mot de passe est requis',
    siteRequired: 'Le site est requis',
  },

  // Calendar
  calendar: {
    calendar: 'Calendrier',
    teamCalendar: 'Calendrier d\'équipe: AZJP',
    goToToday: 'Aller à aujourd\'hui',
    previousWeek: 'Semaine précédente',
    nextWeek: 'Semaine suivante',
    previousMonth: 'Mois précédent',
    nextMonth: 'Mois suivant',
    previousYear: 'Année précédente',
    nextYear: 'Année suivante',
    openMonthPicker: 'Ouvrir le sélecteur de mois',
    closeMonthPicker: 'Fermer le sélecteur de mois',
    weekNumber: 'Semaine {{number}}',
    addEvent: 'Ajouter un événement',
    editEvent: 'Modifier l\'événement',
    eventDetails: 'Détails de l\'événement',
    deleteEvent: 'Supprimer l\'événement',
    createHoliday: 'Cliquez pour créer un congé pour la semaine {{week}} ({{startDate}} - {{endDate}})',
    deleteHoliday: 'Cliquez pour supprimer le congé pour la semaine {{week}} ({{startDate}} - {{endDate}})',
    available: 'Disponible',
    unavailable: 'Indisponible',
    weekend: 'Week-end',
    holiday: 'Congé',
    requestedLeave: 'Congé demandé',
    approvedHoliday: 'Congé approuvé',
    deniedHoliday: 'Congé refusé',
    pendingHoliday: 'Congé en attente',
    requestedDesiderata: 'Desiderata demandé',
    requestedPeriod: 'Demande de période',
    eventCreated: 'Événement créé avec succès',
    eventUpdated: 'Événement mis à jour avec succès',
    eventDeleted: 'Événement supprimé avec succès',
    failedToCreateEvent: 'Échec de la création de l\'événement',
    failedToUpdateEvent: 'Échec de la mise à jour de l\'événement',
    failedToDeleteEvent: 'Échec de la suppression de l\'événement',
    dateNotAvailable: 'Date non disponible',
    onDuty: 'De garde',
    noOnDutyStaff: 'Aucun personnel de garde assigné',
    showMobile: 'Afficher le numéro mobile',
  },

  // Events
  events: {
    title: 'Titre',
    description: 'Description',
    date: 'Date',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    type: 'Type',
    status: 'Statut',
    pending: 'En attente',
    approved: 'Approuvé',
    denied: 'Refusé',
    duration: 'Durée: {{days}} jours',
    untitledEvent: 'Événement sans titre',
    noDescription: 'Pas de description',
    enterTitle: 'Entrez le titre {{type}}',
    enterDescription: 'Entrez la description {{type}}',
    eventType: 'Type d\'événement',
    periodStatus: 'Statut de la période',
    holidayRequestsOpen: 'Les demandes de congés sont ouvertes ({{period}})',
    holidayDesiderataOpen: 'Les demandes de congés et de desiderata sont ouvertes ({{period}})',
    periodClosed: 'La période est fermée pour les demandes ({{period}})',
    unknownStatus: 'Statut inconnu ({{period}})',
    noEventTypesAvailable: 'Aucun type d\'événement disponible',
    periodClosedMessage: 'Cette date est dans une période fermée. La création d\'événement n\'est pas autorisée.',
    cascadedSystem: 'Système en cascade: Les demandes de congés ont priorité sur les desiderata',
    saving: 'Enregistrement...',
    deleting: 'Suppression...',
    changesSaved: 'Modifications enregistrées avec succès',
    failedToSave: 'Échec de l\'enregistrement des modifications',
    modifyDates: 'Modifier les dates',
    extendPeriod: 'Étendre aux week-ends',
    dateModificationNote: 'Les modifications seront appliquées immédiatement après enregistrement.',
    confirmDelete: 'Confirmer la suppression',
    deleteWarning: 'Cette action ne peut pas être annulée.',
    createForColleague: 'Créer un événement pour un collègue',
    selectAtLeastOneTimeSlot: 'Veuillez sélectionner au moins un créneau horaire',
    editApprovedEvent: 'Modifier l\'événement approuvé',
    editApprovedEventWarning: 'Cet événement a été approuvé. Vous ne pouvez modifier que le titre et la description. Les modifications devront être révisées.',
    proceedToEdit: 'Procéder à la modification',
  },

  // Users
  users: {
    userManagement: 'Gestion des utilisateurs',
    addUser: 'Ajouter un utilisateur',
    editUser: 'Modifier l\'utilisateur',
    deleteUser: 'Supprimer l\'utilisateur',
    firstName: 'Prénom',
    lastName: 'Nom',
    email: 'Email',
    role: 'Rôle',
    status: 'Statut',
    admin: 'Administrateur',
    user: 'Utilisateur',
    active: 'Actif',
    inactive: 'Inactif',
    actions: 'Actions',
    searchUsers: 'Rechercher des utilisateurs...',
    allRoles: 'Tous les rôles',
    allStatus: 'Tous les statuts',
    deleteConfirmation: 'Êtes-vous sûr de vouloir supprimer {{name}} ? Cette action ne peut pas être annulée.',
    cannotDeleteLastAdmin: 'Impossible de supprimer le dernier administrateur',
    userCreated: 'Utilisateur créé avec succès',
    userUpdated: 'Utilisateur mis à jour avec succès',
    userDeleted: 'Utilisateur supprimé avec succès',
    failedToCreateUser: 'Échec de la création de l\'utilisateur',
    failedToUpdateUser: 'Échec de la mise à jour de l\'utilisateur',
    failedToDeleteUser: 'Échec de la suppression de l\'utilisateur',
    passwordRequirements: 'Le mot de passe doit comporter au moins 8 caractères et contenir au moins une lettre majuscule, un chiffre et un caractère spécial',
    leaveBlankToKeep: '(laisser vide pour conserver l\'actuel)',
    page: 'Page {{current}} sur {{total}}',
    unknownUser: 'Utilisateur inconnu',
    selectColleague: 'Sélectionner un collègue',
  },

  // Settings
  settings: {
    settings: 'Paramètres',
    colleagues: 'Collègues',
    admin: 'Administrateur',
    display: 'Affichage',
    manageUsers: 'Gérer les utilisateurs',
    manageColleagueDisplay: 'Gérer l\'affichage des collègues',
    subscribeToCalendar: 'S\'abonner au calendrier',
    exportEvents: 'Exporter les événements',
    definePeriods: 'Définir/Modifier les périodes',
    exportAllData: 'Exporter toutes les données (ZIP)',
    reports: 'Rapports',
    weekStartsOn: 'La semaine commence le:',
    showWeekNumber: 'Afficher le numéro de semaine:',
    showWeekends: 'Afficher les week-ends',
    showWerklijsten: 'Afficher les listes de travail (programma)',
    showColleagueHolidayRequests: 'Afficher les demandes de congé des collègues',
    left: 'Gauche',
    right: 'Droite',
    none: 'Aucun',
    colleagueDisplaySettings: 'Paramètres d\'affichage des collègues',
    abbreviation: 'Abréviation',
    color: 'Couleur',
    hideColleague: 'Masquer le collègue',
    showColleague: 'Afficher le collègue',
    editInitials: 'Modifier les initiales',
    clickToEditInitials: 'Cliquez pour modifier les initiales',
    failedToUpdateSettings: 'Échec de la mise à jour des paramètres',
    orderUpdated: 'Ordre des collègues mis à jour avec succès',
    failedToUpdateOrder: 'Échec de la mise à jour de l\'ordre des collègues',
  },

  // Availability
  availability: {
    setAvailability: 'Disponibilité',
    setAvailabilityFor: 'Disponibilité pour {{firstname}} {{lastname}}',
    weeklySchedule: 'Planning hebdomadaire',
    evenWeeks: 'Semaines paires',
    oddWeeks: 'Semaines impaires',
    everyWeek: 'Chaque semaine',
    alternateWeeks: 'Semaines alternées',
    repeatPattern: 'Modèle de répétition',
    addScheduleBefore: 'Ajouter un planning avant',
    addScheduleAfter: 'Ajouter un planning après',
    splitSchedule: 'Diviser le planning',
    deleteSchedule: 'Supprimer le planning',
    extendPrecedingSchedule: 'Étendre le planning précédent',
    extendFollowingSchedule: 'Étendre le planning suivant',
    firstSchedule: 'Premier planning',
    previousSchedule: 'Planning précédent',
    nextSchedule: 'Planning suivant',
    lastSchedule: 'Dernier planning',
    newSchedule: 'Nouveau',
    addNewSchedule: 'Ajouter un nouveau planning',
    splitDate: 'Date de division',
    endDateForCurrentSchedule: 'Date de fin pour le planning actuel',
    newScheduleWillStart: 'Le nouveau planning commencera le {{date}}',
    selectDateBetween: 'Sélectionnez une date entre {{start}} et {{end}} pour diviser le planning.',
    availabilityReport: 'Rapport de disponibilité',
    availabilityReportFor: 'Rapport de disponibilité pour {{name}} - {{year}}',
    viewReport: 'Voir le rapport',
    viewCalendarReport: 'Rapport calendrier',
    clickToToggle: 'Cliquez sur les créneaux horaires pour basculer les mises à jour individuelles. Les modifications sont enregistrées automatiquement.',
    availabilityUpdated: 'Disponibilité mise à jour',
    failedToUpdateAvailability: 'Échec de la mise à jour de la disponibilité',
    morning: 'Matin',
    afternoon: 'Après-midi',
    am: 'AM',
    pm: 'PM',
    toggleAvailability: 'Basculer la disponibilité {{day}} {{period}}',
    timeSlots: 'Créneaux horaires',
    reportLoaded: 'Rapport chargé avec succès',
    failedToCreateSchedule: 'Échec de la création du planning',
    failedToUpdateSchedule: 'Échec de la mise à jour du planning',
    failedToDeleteSchedule: 'Échec de la suppression du planning',
  },

  // Export
  export: {
    exportEvents: 'Exporter les événements',
    exportType: 'Type d\'exportation',
    allEvents: 'Tous les événements',
    myEventsOnly: 'Mes événements uniquement',
    startDateOptional: 'Date de début (Optionnel)',
    endDateOptional: 'Date de fin (Optionnel)',
    leaveDatesEmpty: 'Laissez les dates vides pour exporter tous les événements. Si vous spécifiez une plage de dates, seuls les événements dans cette plage seront exportés.',
    exporting: 'Exportation...',
    preparingExport: 'Préparation de votre fichier d\'exportation...',
    exportDownloaded: 'Fichier d\'exportation téléchargé avec succès!',
    failedToExport: 'Échec de l\'exportation des événements. Veuillez réessayer.',
  },

  // Subscription
  subscription: {
    calendarSubscription: 'Abonnement au calendrier',
    subscribeToYourCalendar: 'Abonnez-vous à votre calendrier',
    subscriptionInstructions: 'Utilisez cette URL pour vous abonner à votre calendrier dans votre application de calendrier préférée:',
    copyUrl: 'Copier l\'URL',
    instructionsFor: 'Instructions pour {{app}}',
    outlook: 'Microsoft Outlook',
    googleCalendar: 'Google Calendar',
    appleCalendar: 'Apple Calendar',
    otherApplications: 'Autres applications',
    outlookInstructions: [
      'Ouvrez Outlook Desktop ou Outlook Web',
      'Faites un clic droit sur Calendrier dans le volet de navigation',
      'Sélectionnez "Ajouter un calendrier" → "À partir d\'Internet"',
      'Collez l\'URL d\'abonnement',
      'Cliquez sur "OK" ou "Enregistrer"',
      'Choisissez la fréquence à laquelle Outlook doit synchroniser le calendrier',
      'Cliquez sur "Oui" pour ajouter le calendrier'
    ],
    googleInstructions: [
      'Ouvrez Google Calendar dans votre navigateur',
      'Sur le côté gauche, trouvez "Autres calendriers" et cliquez sur le bouton "+"',
      'Sélectionnez "À partir de l\'URL" dans le menu déroulant',
      'Collez l\'URL d\'abonnement dans le champ "URL"',
      'Cliquez sur "Ajouter un calendrier"',
      'Le calendrier apparaîtra sous "Autres calendriers" dans votre liste de calendriers'
    ],
    appleInstructions: [
      'Ouvrez l\'application Calendrier sur votre Mac',
      'Dans la barre de menu, sélectionnez Fichier',
      'Choisissez "Nouvel abonnement au calendrier"',
      'Collez l\'URL d\'abonnement',
      'Cliquez sur "S\'abonner"',
      'Configurez la fréquence de synchronisation et d\'autres options selon vos besoins',
      'Cliquez sur "OK" pour terminer'
    ],
    appleIosInstructions: [
      'Allez dans Réglages → Calendrier → Comptes',
      'Appuyez sur "Ajouter un compte" → "Autre" → "Ajouter un calendrier avec abonnement"',
      'Collez l\'URL d\'abonnement',
      'Appuyez sur "Suivant" puis sur "Enregistrer"'
    ],
    otherInstructions: [
      'Recherchez une option pour ajouter un abonnement au calendrier ou "S\'abonner au calendrier"',
      'Lorsque vous y êtes invité, collez l\'URL d\'abonnement fournie ci-dessus',
      'Configurez la fréquence de synchronisation si l\'option est disponible',
      'Enregistrez ou confirmez l\'abonnement'
    ],
    icalNote: 'Remarque: Le calendrier utilise le format iCalendar (.ics), qui est compatible avec la plupart des applications de calendrier modernes.',
    failedToFetchUrl: 'Échec de la récupération de l\'URL d\'abonnement',
  },

  // Periods
  periods: {
    periodManagement: 'Gestion des périodes',
    addPeriod: 'Ajouter une période',
    editPeriod: 'Modifier la période',
    deletePeriod: 'Supprimer la période',
    resetToDefaults: 'Réinitialiser aux valeurs par défaut',
    saveChanges: 'Enregistrer les modifications',
    nameLabel: 'Nom/Étiquette',
    editingStatus: 'Statut d\'édition',
    closed: 'Fermé',
    openHoliday: 'Ouvert - Congés',
    openDesiderata: 'Ouvert - Desiderata',
    defaultClosed: 'Par défaut: Fermé',
    enterPeriodName: 'Entrez le nom de la période',
    updatePeriod: 'Mettre à jour la période',
    noPeriodsForYear: 'Aucune période définie pour {{year}}. Cliquez sur "Ajouter une période" pour commencer.',
    resetConfirmation: 'Êtes-vous sûr de vouloir réinitialiser aux périodes par défaut? Cela écrasera toutes les périodes actuelles.',
    periodsSaved: 'Périodes enregistrées avec succès',
    periodsReset: 'Périodes réinitialisées aux valeurs par défaut',
    failedToSavePeriods: 'Échec de l\'enregistrement des périodes',
    failedToResetPeriods: 'Échec de la réinitialisation des périodes',
    failedToLoadPeriods: 'Échec du chargement des périodes',
    validationErrors: {
      nameRequired: 'Le nom est requis',
      startDateRequired: 'La date de début est requise',
      endDateRequired: 'La date de fin est requise',
      endDateAfterStart: 'La date de fin doit être postérieure à la date de début',
      overlappingDates: 'Les dates de la période chevauchent une période existante',
      periodsOverlap: 'Les périodes "{{period1}}" et "{{period2}}" ont des dates qui se chevauchent',
    },
  },

  // Connection Status
  connection: {
    connected: 'Connecté aux mises à jour en temps réel',
    disconnected: 'Déconnecté des mises à jour en temps réel',
    lostConnection: 'Connexion perdue aux mises à jour en temps réel',
    reconnecting: 'Tentative de reconnexion...',
  },

  // Notifications
  notifications: {
    eventCreatedByColleague: 'Événement {{action}} par un collègue',
    colleagueUpdatedAvailability: 'Un collègue a mis à jour sa disponibilité',
    userConnected: 'Utilisateur connecté',
    userDisconnected: 'Utilisateur déconnecté',
    requestApproved: 'Demande approuvée avec succès',
    requestDenied: 'Demande refusée avec succès',
    failedToApprove: 'Échec de l\'approbation de la demande',
    failedToDeny: 'Échec du refus de la demande',
    updatedEvents: '{{count}} événements mis à jour',
    failedToUpdateEvents: 'Échec de la mise à jour des événements',
  },

  // Admin Holiday Modal
  adminHoliday: {
    requestManagement: 'Gestion des demandes',
    adminReview: 'Revue administrative',
    employeeInformation: 'Informations sur l\'employé',
    currentStatus: 'Statut actuel',
    requestType: 'Type de demande',
    dateRange: 'Plage de dates',
    requestDetails: 'Détails de la demande',
    submissionInfo: 'Soumis le {{date}}',
    lastUpdated: 'Dernière mise à jour le {{date}}',
    approveRequest: 'Approuver la demande',
    denyRequest: 'Refuser la demande',
    processing: 'Traitement...',
    clickToManage: 'Cliquez pour gérer la demande de {{name}}',
    clickToViewDetails: 'Cliquez pour voir les détails',
  },

  // Desiderata
  desiderata: {
    desiderataDays: 'Desiderata',
    workingDays: 'Jours ouvrables',
    weekendDays: 'Jours de week-end',
    remaining: 'Restant',
    priority: 'Priorité',
    limitExceeded: 'Limite de sélection dépassée',
    approachingLimit: 'Approche de la limite de sélection',
    totalAvailable: 'Total disponible',
    publicHolidays: 'Jours fériés',
    mandatoryExtension: 'Sélection étendue en raison des règles de week-end obligatoires',
    autoExtendedToWeekend: 'Sélection automatiquement étendue pour inclure le week-end',
  },

  // Version Display
  version: {
    systemInformation: 'Informations système',
    frontend: 'Frontend',
    backend: 'Backend',
    version: 'Version:',
    buildDate: 'Date de build:',
    environment: 'Environnement:',
    targetUrl: 'URL cible:',
    status: 'Statut:',
    uptime: 'Temps de fonctionnement:',
    lastCheck: 'Dernière vérification:',
    refreshHealthCheck: 'Actualiser la vérification de santé',
    checking: 'Vérification...',
    production: 'production',
    development: 'développement',
    healthy: 'en bonne santé',
    error: 'Erreur',
  },

  // Days of the week (short)
  days: {
    sun: 'Dim',
    mon: 'Lun',
    tue: 'Mar',
    wed: 'Mer',
    thu: 'Jeu',
    fri: 'Ven',
    sat: 'Sam',
  },

  // Months
  months: {
    january: 'Janvier',
    february: 'Février',
    march: 'Mars',
    april: 'Avril',
    may: 'Mai',
    june: 'Juin',
    july: 'Juillet',
    august: 'Août',
    september: 'Septembre',
    october: 'Octobre',
    november: 'Novembre',
    december: 'Décembre',
  },

  // Error messages
  errors: {
    somethingWentWrong: 'Une erreur s\'est produite',
    failedToLoadData: 'Échec du chargement des données',
    networkError: 'Erreur réseau',
    unauthorized: 'Non autorisé',
    forbidden: 'Interdit',
    notFound: 'Non trouvé',
    internalServerError: 'Erreur interne du serveur',
    validationError: 'Erreur de validation',
    unknownError: 'Erreur inconnue',
  },

  // Public holidays
  publicHolidays: {
    newYearsDay: 'Jour de l\'An',
    easterSunday: 'Dimanche de Pâques',
    easterMonday: 'Lundi de Pâques',
    labourDay: 'Fête du Travail',
    ascensionDay: 'Ascension',
    whitSunday: 'Pentecôte',
    whitMonday: 'Lundi de Pentecôte',
    belgianNationalDay: 'Fête Nationale Belge',
    assumptionDay: 'Assomption',
    allSaintsDay: 'Toussaint',
    armisticeDay: 'Armistice',
    christmasDay: 'Noël',
    goodFriday: 'Vendredi Saint',
    earlyMayBankHoliday: 'Jour férié de début mai',
    springBankHoliday: 'Jour férié de printemps',
    summerBankHoliday: 'Jour férié d\'été',
    boxingDay: 'Lendemain de Noël',
  },

  // Documents
  documents: {
    downloadSchedule: 'Télécharger le planning de garde (PDF)',
    downloadFailed: 'Échec du téléchargement. Veuillez réessayer.',
    invalidFileType: 'Type de fichier invalide. Seuls les fichiers PDF sont autorisés.',
    invalidFilename: 'Nom de fichier invalide.',
    fileNotFound: 'Document introuvable.',
    failedToDownload: 'Échec du téléchargement du document.',
    failedToListDocuments: 'Échec de la récupération de la liste des documents.',
  },

  // Reports
  reports: {
    desiderata: 'Desiderata',
    desiderataReport: 'Rapport Desiderata',
    desiderataReportDescription: 'Exporter les données desiderata vers Excel',
    desiderataReportInstructions: 'Sélectionnez une année et une période pour générer un rapport Excel affichant les demandes desiderata de tous les membres de l\'équipe.',
    availability: 'Disponibilité',
    availabilityReport: 'Rapport de Disponibilité',
    availabilityReportDescription: 'Exporter les horaires de disponibilité de l\'équipe vers Excel',
    availabilityReportInstructions: 'Générez un rapport Excel affichant les horaires de travail et la disponibilité de tous les membres de l\'équipe.',
    aggregatedAvailability: 'Disponibilité Agrégée',
    aggregatedAvailabilityDescription: 'Exporter les membres d\'équipe indisponibles par date',
    aggregatedAvailabilityInstructions: 'Générez un rapport Excel affichant quels membres de l\'équipe sont indisponibles pour chaque date/période.',
    unavailableUsers: 'Utilisateurs Indisponibles',
    aggregatedLeave: 'Congés Agrégés',
    aggregatedLeaveDescription: 'Exporter les membres d\'équipe en congé par date',
    aggregatedLeaveInstructions: 'Générez un rapport Excel affichant quels membres de l\'équipe sont en congé pour chaque date/période.',
    usersOnLeave: 'Utilisateurs en Congé',
    period: 'Période',
    date: 'Date',
    total: 'Total',
    selectPeriod: 'Veuillez sélectionner une période',
    noDataAvailable: 'Aucune donnée disponible pour la période sélectionnée',
    noPeriodsAvailable: 'Aucune période disponible',
    exporting: 'Exportation...',
    exportToExcel: 'Exporter vers Excel',
    exportSuccess: 'Rapport exporté avec succès',
    exportFailed: 'Échec de l\'exportation du rapport. Veuillez réessayer.',
  },
};